import axios from "axios";
import {endpoint, token_refresh_URL, logoutURL} from "./constants";
import {openNotificationWithIcon} from "./containers/Function";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const authAxiosTest = (token) => {
    const axiosTest = axios.create({
          baseURL: endpoint,
          headers: {
            Authorization: `Bearer ${token}`,
          }
    });

    axiosTest.interceptors.response.use(response => {
        return response;
    }, error => {
        return new Promise((resolve, reject) => {
            const oroginReq = error.config;
            try {
                if(error.response.status === 400) {
                    console.log(error);
                    // const dataError = Object.entries(error.response.data).map(([key,value]) => (<p>{value}</p>))
                    // openNotificationWithIcon('error','Lỗi',dataError)
                    // return false
                    reject(error.response)
                    // message.error("Không tìm thấy dữ liệu");
                }
                else if(error.response.status === 404 || error.response.status === 500) {
                    const token = cookies.get('token')
                    if (!token) {
                        window.location = "/login"
                    }
                    openNotificationWithIcon('error','Lỗi',"Không tìm thấy dữ liệu")
                    // message.error("Không tìm thấy dữ liệu");
                }
                else if ( error.response.status === 401 && error.config) {
                    oroginReq._retry = true;

                    // let refresh = cookies.get('refresh');
                    // if (refresh) {
                    //     let res = fetch(token_refresh_URL, {
                    //         method: 'POST',
                    //         mode: 'cors',
                    //         headers: {
                    //             'Content-Type': 'application/json'
                    //         },
                    //         body: JSON.stringify({
                    //             refresh: cookies.get('refresh')
                    //         })
                    //     }).then(res => res.json()).then(res => {
                    //         oroginReq.headers.Authorization = `Bearer ${res.access}`;
                    //         localStorage.setItem("token",res.access);
                    //         return axios(oroginReq);
                    //     });
                    //     resolve(res);
                    // } else {
                    //     console.log("not login")
                    //     window.location = '/login';
                        // window.location(urlAuthServer)
                        // window.location = localhost +  '/api/test_call_server/?redirect_uri=http://test2.rainscales.com.vn/auth&client=client_03';
                    // }

                    axios
                    .get(logoutURL)
                    .then(res => {
                        localStorage.clear();
                        document.cookie.split(";").forEach((c) => {
                            document.cookie = c
                            .replace(/^ +/, "")
                            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                        });
                        window.location.href = '/login'
                    })
                    .catch(err => {
                        console.log(err)
                    });
                }
            } catch (e) {
                localStorage.setItem('error_s','1')
                // logout();
                window.location = '/login';

                // window.location = localhost +  '/api/test_call_server/?redirect_uri=http://test2.rainscales.com.vn/auth&client=client_03'
                    // message.success('Lỗi kết nối, kiểm tra kết nối tới server1 !!!', 10);
            }
            // console.log(error.response.data.username);
            // debugger

            // return Promise.reject(error);
            Promise.reject(error).then(function() {
                return Promise.reject(error);
            }, function(error) {
                return error;
            });


        })
        // .then(function() {
        //     console.log("1");
        // }, function(error) {
        //     console.log(error);
        //     return error;
        // });

    });
    return axiosTest;
};



export const authAxios = (token) => authAxiosTest(token);
